export function applyJourneyPreview(journeys, previewJourney) {
  if (!previewJourney) return journeys;
  const idx = journeys.findIndex((j) => j.journey_id === previewJourney.journey_id);
  if (idx < 0) return journeys;
  return journeys.map((j) => (j.journey_id === previewJourney.journey_id
    ? { ...j, name: previewJourney.name, state_enum: previewJourney.state_enum, channels: previewJourney.channels, segment_id: previewJourney.segment_id != null ? previewJourney.segment_id : j.segment_id }
    : j));
}
